import { HttpError } from '@forto-dev/ui-platform-http'
import { History } from 'history'
import { action, observable } from 'mobx'
import { LocalisationStore } from 'utils/localisation'

import { DialogService } from './internal/DialogService'

interface IPageError {
  error: Error | null
}

interface ErrorServiceProps {
  dialog: DialogService
  localisationStore: LocalisationStore
  log: (message: string) => void
  history: History
}

export class ErrorService {
  dialog: DialogService
  @observable
  currentPageError: IPageError = {
    error: null,
  }
  log: ErrorServiceProps['log']
  history: History
  private localisationStore: LocalisationStore
  constructor(props: ErrorServiceProps) {
    this.dialog = props.dialog
    this.localisationStore = props.localisationStore
    this.log = props.log
    this.history = props.history
  }

  @action
  process(err: Error) {
    this.processCurrentPageError(err)
  }

  @action
  processCurrentPageError(err: Error) {
    this.currentPageError.error = err
    // Added 401 because quote sheet endpoint returns 401 instead of 403 when user does not have access to quote sheet
    // TODO: Remove 401 once this issue is fixed on the backend
    if (err instanceof HttpError && [401, 403, 404].some((statusCode) => err.status === statusCode)) {
      this.showGeneralExpirationError()
      this.history.replace('/')
    }
  }

  @action
  resetCurrentPageError() {
    this.currentPageError.error = null
  }

  @action
  showDialog(errorString) {
    this.dialog.show({
      title: this.localisationStore.translate('error_popup-title'),
      content: errorString,
    })
  }

  @action
  showErrorDialog(err: HttpError, defaultMessage?: string) {
    const { status, statusText } = err
    this.dialog.show({
      title: this.localisationStore.translate('error_popup-title') + (status ? ` ${status}` : ''),
      content: err.message || defaultMessage || statusText || '',
    })
  }

  @action
  showGeneralError() {
    this.dialog.show({
      title: this.localisationStore.translate('error_popup-title'),
      content: this.localisationStore.translate('error_popup-server_error_text'),
    })
  }

  @action
  showGeneralExpirationError() {
    this.showDialog(this.localisationStore.translate('error_popup-quote_sheet_expired'))
  }
}
